export default {
    routerName: '登録',
    user: {
        loginName: 'アカウント',
        password: 'パスワード',
        name: '氏名',
        email: 'メール',
        mobile: '電話番号',
        sex: '性別',
        male: '男性',
        female: '女性',
        captcha: 'キャプチャ',
    },
};
